var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M8.51601 9.59403H6.52424L4.30839 11.068C3.97975 11.287 3.53659 11.053 3.53659 10.6547V9.59403C2.04276 9.59403 1.04688 8.59815 1.04688 7.10432V4.11667C1.04688 2.62284 2.04276 1.62695 3.53659 1.62695H8.51601C10.0098 1.62695 11.0057 2.62284 11.0057 4.11667V7.10432C11.0057 8.59815 10.0098 9.59403 8.51601 9.59403Z",
    fill: "#92ABFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.0262 6.44664C5.82204 6.44664 5.65274 6.27734 5.65274 6.07318V5.96863C5.65274 5.39102 6.07599 5.10719 6.23533 4.99764C6.41957 4.87315 6.47931 4.78851 6.47931 4.65904C6.47931 4.41007 6.27517 4.2059 6.0262 4.2059C5.77723 4.2059 5.57309 4.41007 5.57309 4.65904C5.57309 4.8632 5.40379 5.0325 5.19963 5.0325C4.99547 5.0325 4.82617 4.8632 4.82617 4.65904C4.82617 3.99678 5.36394 3.45898 6.0262 3.45898C6.68846 3.45898 7.22623 3.99678 7.22623 4.65904C7.22623 5.2267 6.80797 5.51052 6.65361 5.61508C6.45941 5.74455 6.39966 5.82921 6.39966 5.96863V6.07318C6.39966 6.28232 6.23036 6.44664 6.0262 6.44664Z",
    fill: "#92ABFE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.0258 7.68637C5.81666 7.68637 5.65234 7.51707 5.65234 7.31291C5.65234 7.10875 5.82164 6.93945 6.0258 6.93945C6.22996 6.93945 6.39926 7.10875 6.39926 7.31291C6.39926 7.51707 6.23494 7.68637 6.0258 7.68637Z",
    fill: "#92ABFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/Question.5a23d6e9dc15b7f4d9ad1126d9dc7ca9.svg";
export { ForwardRef as ReactComponent };